module.exports = __webpack_public_path__ + "static/media/sportsbook.5f7097e4.svg";